var router = require('pjax').Router;
var index = require('./index.js');
var gallery = require('./gallery.js');
var slideshow = require('./slideshow.js');

router.get('gallery/([a-zA-Z]+)', index);
router.get('gallery/([a-zA-Z]+)/([a-zA-Z]+)', gallery);
router.get('gallery/([a-zA-Z]+)/([a-zA-Z]+)/slideshow', slideshow);
router.get('gallery/([a-zA-Z]+)/([a-zA-Z]+)/(?!slideshow)([a-zA-Z]+)', gallery);
